import { faUser } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const pillClass =
  'vai-flex vai-h-10 vai-shrink-0 vai-items-center vai-gap-2 vai-rounded-md vai-border vai-border-zinc-200 vai-bg-white vai-px-4 vai-py-2';

export interface ProviderPillProps {
  name: string;
  className?: string;
}

export function ProviderPill({ name, className = '' }: ProviderPillProps) {
  return (
    <div className={`${pillClass} ${className}`} role="presentation">
      <FontAwesomeIcon
        icon={faUser}
        className="vai-h-4 vai-w-4 vai-text-muted-foreground"
      />
      <span className="vai-truncate vai-text-sm vai-leading-5 vai-text-zinc-900">
        {name}
      </span>
    </div>
  );
}
